import { DataMap } from '@shared/utils/dataMapping';
import { BackendKeyToURLKey } from '@shared/utils/dataMappingConstants';
import { Constants } from '@shared/utils/constants';
import { bitMasksMatchFilter } from '@shared/utils/datamappingHelpers';
export function getProductTitleForTile(serviceProducts) {
    let products = '';
    // eslint-disable-next-line array-callback-return
    Object.keys(DataMap.products).map((value)=>{
        if (serviceProducts && bitMasksMatchFilter(serviceProducts, DataMap.products[`${value}`])) {
            // If the product is a d365 sub prod just insert d365 once for all the sub products, else insert the product
            if (DataMap.products.Dynamics365.ShortcutFilters.indexOf(value) > -1 && products.indexOf(DataMap.products.Dynamics365.LongTitle) < 0) {
                products += DataMap.products.Dynamics365.LongTitle + ' | ';
            } else if (DataMap.products.Dynamics365.ShortcutFilters.indexOf(value) < 0) {
                // !!! Temporary HACK: If the product is 'Power BI apps' we want to display it as 'Power BI'
                // in Consulting services tab alone.
                let longTitle = DataMap.products[`${value}`].LongTitle;
                if (longTitle === 'Power BI apps') {
                    longTitle = 'Power BI';
                }
                products += longTitle + ' | ';
            }
        }
    });
    return products.substring(0, products.lastIndexOf('|'));
}
function getServicePricingByCountry(multiGeoCountryPricings, country) {
    var _multiGeoCountryPricings_find;
    return multiGeoCountryPricings === null || multiGeoCountryPricings === void 0 ? void 0 : (_multiGeoCountryPricings_find = multiGeoCountryPricings.find((multiGeoCountryPricing)=>{
        var _multiGeoCountryPricing_countryRegion;
        return ((_multiGeoCountryPricing_countryRegion = multiGeoCountryPricing.countryRegion) === null || _multiGeoCountryPricing_countryRegion === void 0 ? void 0 : _multiGeoCountryPricing_countryRegion.toLowerCase()) === (country === null || country === void 0 ? void 0 : country.toLowerCase());
    })) === null || _multiGeoCountryPricings_find === void 0 ? void 0 : _multiGeoCountryPricings_find.pricing;
}
export function getServicePricingByCountryWithFallback(multiGeoCountryPricings, country) {
    var _multiGeoCountryPricings_;
    return getServicePricingByCountry(multiGeoCountryPricings, country) || getServicePricingByCountry(multiGeoCountryPricings, Constants.usCountryCode) || (multiGeoCountryPricings === null || multiGeoCountryPricings === void 0 ? void 0 : (_multiGeoCountryPricings_ = multiGeoCountryPricings[0]) === null || _multiGeoCountryPricings_ === void 0 ? void 0 : _multiGeoCountryPricings_.pricing);
}
export function getCountryRegionByCountry({ service, countryCode }) {
    var _service_extraData;
    if (!(service === null || service === void 0 ? void 0 : (_service_extraData = service.extraData) === null || _service_extraData === void 0 ? void 0 : _service_extraData.multiCountryPricing) || !countryCode) {
        return null;
    }
    const { multiCountryPricing } = service.extraData;
    const countryCodeUpper = countryCode.toUpperCase();
    return multiCountryPricing.find(({ countryRegion })=>countryRegion === countryCodeUpper) || multiCountryPricing[0];
}
export function findBestMatchCountryCode(multiCountryServicePricing, country) {
    if (country && multiCountryServicePricing && multiCountryServicePricing.length > 0) {
        for(let i = 0; i < multiCountryServicePricing.length; i++){
            if (multiCountryServicePricing[`${i}`].countryRegion && multiCountryServicePricing[`${i}`].countryRegion.toLowerCase() === country.toLowerCase()) {
                return multiCountryServicePricing[`${i}`].countryRegion;
            }
        }
        // Input country not found - return the first country we can find.
        return multiCountryServicePricing[0].countryRegion;
    }
    return null;
}
export function extractCountryCodeFromFilterQueryParam(query) {
    // Try to get (AMP) filter-country query param.
    if (typeof (query === null || query === void 0 ? void 0 : query.filters) === 'string') {
        const subFilters = query.filters.split(';');
        if (subFilters && subFilters.length > 0) {
            for(let i = 0; i < subFilters.length; i++){
                if (subFilters[`${i}`] && subFilters[`${i}`].toLowerCase().indexOf('country-') !== -1) {
                    for(const key in BackendKeyToURLKey){
                        if (BackendKeyToURLKey[`${key}`].toLowerCase() === subFilters[`${i}`].toLowerCase()) {
                            return key;
                        }
                    }
                }
            }
        }
    }
    return null;
}
export function extractCountryCodeFromCountryQueryParam(query) {
    return query && query.country ? query.country : null;
}
export function extractCountryCodeFromQueryParam(query) {
    // Try to get country code from country(AppSource) query param.
    let countryCode = extractCountryCodeFromCountryQueryParam(query);
    if (countryCode) {
        return countryCode;
    }
    // Try to get country code from filter-country(AMP) query param.  }
    countryCode = extractCountryCodeFromFilterQueryParam(query);
    if (countryCode) {
        return countryCode;
    }
    return null;
}
export function createCountryFilterQueryParam(countryCode, isAppSource) {
    if (isAppSource) {
        return {
            [Constants.countryCodeQueryParam]: countryCode
        };
    } else {
        return {
            [Constants.FilterQuery.filters]: BackendKeyToURLKey[`${countryCode}`]
        };
    }
}
export function getReplacedCountryQueryParam(query, newCountryCode) {
    if (!query || !newCountryCode) {
        return null;
    }
    // AppSource
    if (query.country) {
        return {
            [Constants.countryCodeQueryParam]: newCountryCode
        };
    }
    // AMP
    if (query.filters) {
        const countryCodeToReplace = extractCountryCodeFromFilterQueryParam(query);
        // No country code to replace.
        let newFilter;
        if (!countryCodeToReplace) {
            if (query.filters.length > 0) {
                newFilter = query.filters += ';' + BackendKeyToURLKey[`${newCountryCode}`];
            } else {
                newFilter = BackendKeyToURLKey[`${newCountryCode}`];
            }
        } else {
            newFilter = query.filters.toLowerCase().replace(BackendKeyToURLKey[`${countryCodeToReplace}`], BackendKeyToURLKey[`${newCountryCode}`]);
        }
        return {
            [Constants.FilterQuery.filters]: newFilter
        };
    }
    return null;
}
export function getStartingPriceCurrency(multiCountryPricing, country) {
    const pricing = getServicePricingByCountryWithFallback(multiCountryPricing, country);
    return (pricing === null || pricing === void 0 ? void 0 : pricing.currencyCode) || Constants.usdCurrency;
}
export function getStartingPriceHeader(multiCountryPricing, country, locale, context) {
    var _pricing_planPrices;
    const pricing = getServicePricingByCountryWithFallback(multiCountryPricing, country);
    const currency = pricing === null || pricing === void 0 ? void 0 : pricing.currencyCode;
    const planPrice = pricing === null || pricing === void 0 ? void 0 : (_pricing_planPrices = pricing.planPrices) === null || _pricing_planPrices === void 0 ? void 0 : _pricing_planPrices[0];
    const header = (planPrice === null || planPrice === void 0 ? void 0 : planPrice.price) ? planPrice.price.toLocaleString(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    }) : context.loc('Pricing_Free');
    return header;
}
